import React from "react";

import { ChangeRequestResponseForm } from "./ChangeRequestResponseForm";

export class ChangeRequestResponseContainer extends React.PureComponent {
  render() {
    return <ChangeRequestResponseForm />;
  }
}
